import { FormattedHTMLMessage, FormattedReactMessage } from '@99designs/common/i18n';
import Link from 'launch/components/Link';
import React from 'react';

interface Props {
    name: string;
    url?: string;
    hasPreposition?: boolean;
    color?: Color;
    size?: Size;
}

type Color = 'grey700' | 'white';
type Size = 'subtle' | 'root';

export default function Attribution({
    name,
    url,
    color = 'grey700',
    size = 'subtle',
    hasPreposition = true,
}: Props) {
    const attributionName = url ? (
        <Link href={url} target="_blank" variations={[size, color]}>
            {name}
        </Link>
    ) : (
        <>{name}</>
    );

    let attribution;

    if (hasPreposition) {
        if (url) {
            attribution = (
                <FormattedReactMessage
                    message={__('by <DesignerLink>{designer}</DesignerLink>')}
                    values={{ designer: name }}
                    replacements={{ DesignerLink: attributionName }}
                />
            );
        } else {
            attribution = (
                <FormattedHTMLMessage message={__('by {designer}')} values={{ designer: name }} />
            );
        }
    } else {
        attribution = attributionName;
    }

    return (
        <span className="get-started-interactive-content--item-card-attribution">
            {attribution}
        </span>
    );
}
